module.exports = "/assets/0826238de4cc96ce17cbfa74536f145a.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/X3.png
// module id = 1982
// module chunks = 0